import { useMainStore } from '~/store/main/main.store'

export default defineNuxtRouteMiddleware(() => {
  const mainStore = useMainStore()
  const provider = computed(() => mainStore.getDomainConfig)

  if (provider.value?.provider.id !== 1) {
    throw createError({
      statusCode: 404,
      fatal: true,
      message: 'page not found',
    })
  }
})
